module.exports = __webpack_public_path__ + "img/Pista_24.2b622000.png";